import React, { useEffect, useState, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import Maintenance from '../../../functions/logic/Maintenance'
import DynamicTable from '../../../components/DataTables/DynamicTable'
import Spiner from '../../../components/Spiner'
import FormModal from '../../../components/General/FormModal'
import ImgVideoModal from '../../../components/ImgVideoModal'
import ConfirmModal from '../../../components/ConfirmModal'
import { useSnackbar } from 'notistack'

export default function Catalogos() {
    const [spiner, setSpiner] = useState(false)
    const [selectedOption, setSelectedOption] = useState("")
    const param = useParams()
    const { enqueueSnackbar } = useSnackbar()
    const userToken = localStorage.getItem('userToken')

    const getProdcuts = useCallback(async (page, perPage, param) => {
        setSpiner(true)
        global.MENU_MODULE_SELECT = 'mantenimiento'
        localStorage.setItem('param', JSON.stringify(param.moduleId))

        setSpiner(false)
    }, [enqueueSnackbar, userToken]) 

    useEffect(() => {
        getProdcuts(1, 5, param)
    }, [param, getProdcuts])

    return (
        <>
            <Spiner opt={spiner} />
            <div className="content-wrapper">
                <section className="content-header">
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="form-group">
                                            <label>Seleccione una opción:</label>
                                            <select 
                                                className="form-control"
                                                value={selectedOption} 
                                                onChange={(e) => setSelectedOption(e.target.value)}
                                            >
                                                <option value="">-- Seleccionar --</option>
                                                <option value="productos">Productos</option>
                                                <option value="categorias">Categorías</option>
                                            </select>
                                        </div>
                                        <div className="project-actions text-right">
                                            {selectedOption && (
                                                <button className="btn btn-primary btn-sm">
                                                    <i className="fas fa-folder"></i> Nuevo Producto
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="col-md-12">
                                            {selectedOption && <DynamicTable />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
            </div >
        </>
    )
}
